import _camelCase from "lodash/camelCase"
import _isBoolean from "lodash/isBoolean"
import _isDate from "lodash/isDate"
import _isNumber from "lodash/isNumber"
import _isObject from "lodash/isObject"
import _isString from "lodash/isString"
import _reduce from "lodash/reduce"
import _snakeCase from "lodash/snakeCase"

const transformKeysWithFunction =
  (converterFunction: typeof _camelCase | typeof _snakeCase) =>
  (object: unknown): unknown => {
    // these conditions are used in order to skip object-wrapped primitives like 'new String()' or 'new Date()'
    if (!_isObject(object) || _isString(object) || _isNumber(object) || _isBoolean(object) || _isDate(object)) {
      return object
    }
    return Array.isArray(object)
      ? object.map(value => transformKeysWithFunction(converterFunction)(value))
      : _reduce(
          object,
          (result, value, key) => {
            // sometimes we receive multiple values separated by ':' char (e.g. location) from disjunctive facets
            const formattedkey = key.includes(":")
              ? key
                  .split(":")
                  .reduce((acc, keyValue) => `${acc}:${converterFunction(keyValue)}`, "")
                  .slice(1)
              : converterFunction(key)

            return {
              ...result,
              [formattedkey]: transformKeysWithFunction(converterFunction)(value),
            }
          },
          {}
        )
  }
export const keysToCamelCase = <T>(object: unknown): T => transformKeysWithFunction(_camelCase)(object) as T
export const keysToSnakeCase = <T>(object: unknown): T => transformKeysWithFunction(_snakeCase)(object) as T
